export default __webpack_public_path__ + "media/images/ad_landing_page/desktop_logo-76b04dd463c06a91f44866ff12abe4a7.svg";